<template>
  <div class="product-page about-page">
    <main id="main-content">
      <AboutHeroSection />
      <AboutCompanySection />
      <AboutCultureSection />
      <AboutHonorsSection />
    </main>
  </div>
</template>

<script setup lang="ts">
import AboutCompanySection from '@/components/about/AboutCompanySection.vue';
import AboutCultureSection from '@/components/about/AboutCultureSection.vue';
import AboutHeroSection from '@/components/about/AboutHeroSection.vue';
import AboutHonorsSection from '@/components/about/AboutHonorsSection.vue';
import { useSeo } from '@/composables/useSeo';
import '@/styles/newhome/product-page.css';

useSeo({
  title: '关于海曦｜国产化AI算力与智能解决方案领导者，公司简介、企业文化与荣誉资质',
  description:
    '海曦技术（HYXINO）聚焦国产化AI算力与场景化解决方案，构建自主可控的全栈技术体系，深耕政务、医疗、工业等行业，累计服务客户超100家，拥有多项权威认证与知识产权成果。'
});
</script>
